import React, { Suspense } from 'react';

export const PatientsComponent = React.lazy(() => import('./Patients'));

export const Patients = () => (
  <Suspense fallback={null}>
    <PatientsComponent />
  </Suspense>
);
